const environment = process.env.REACT_APP_ENVIRONMENT!.toLocaleLowerCase();
const isProduction = environment == 'production';

const premiumEtfsTickers = process.env.REACT_APP_PREMIUM_ETF_TICKERS!;

export const adjustImageUrl = (url: string) => {
	return isProduction
		? '/frontend-react-res' + url
		: url;
}

export const getPremiumEtfTickers = () => {
	return premiumEtfsTickers.split(',');
}